import { captureException } from '@contra/sentry/react';

export const getUrlHostname = (url: null | string): null | string => {
  if (!url) return null;
  try {
    return new URL(url).hostname;
  } catch (error) {
    captureException(error);
    return null;
  }
};
